<template>
  <div class="launchTime">
    <!-- {{ sum }}
    <div @click="jia">jia</div> -->
    <div class="launchTime_titleArea">
      <h3 class="title">投放时间</h3>
    </div>
    <div class="launchTime_main">
      <div class="main_item">
        <div class="item_title">
          <span class="text">投放时间</span>
        </div>
        <div class="item_main">
          <!-- <el-radio
            v-model="launchTime1"
            label="1"
          >选择开始和结束日期</el-radio>
          <el-radio
            v-model="launchTime1"
            label="2"
          >长期投放</el-radio> -->
          <div>
            <el-radio-group v-model="radioBabyone" @change="onechange">
              <el-radio :label="'sone'">选择开始和结束日期</el-radio>
              <el-radio :label="'sone1'">长期投放</el-radio>
            </el-radio-group>
          </div>

        </div>
      </div>
      <div class="main_item">
        <div class="item_title">
          <span v-if="radioBabyone==='sone'" class="text">开始日期与结束日期</span>
          <span v-else class="text">开始时间</span>
        </div>
        <div class="item_main">
          <el-date-picker
            v-model="startTime1"
            :clearable="false"
            format="yyyy-MM-dd"
            value-format="timestamp"
            type="date"
            placeholder="选择日期"
            size="mini"
            :picker-options="pickerOptions"
            @change="startChange"
          />
          <span v-show="radioBabyone==='sone'">-</span>
          <el-date-picker
            v-show="radioBabyone==='sone'"
            v-model="endTime1"
            :clearable="false"
            type="date"
            placeholder="结束时间"
            format="yyyy-MM-dd"
            value-format="timestamp"
            size="mini"
            :picker-options="pickerOptions"
            @change="endChange"
          />
        </div>
      </div>
      <div class="main_item" style="display:none">
        <div class="item_title">
          <span class="text">投放时间段</span>
        </div>

        <el-radio-group v-model="radioBabytwo" @change="onechangetwo">
          <el-radio :label="radiobig">全天投放</el-radio>
          <el-radio :label="radiomiddle">每日相同时段</el-radio>
          <el-radio :label="radiothree">自定义时段</el-radio>
        </el-radio-group>
      </div>

      <div v-show="radioBabytwo === radiomiddle">
        <div class="main_item">
          <div class="item_title">
            <span class="text">每日投放时段</span>
          </div>
          <div class="item_main" />
        </div>
        <el-time-select
          v-model="time"
          :clearable="false"
          :picker-options="{
            start: '00:00',
            step: '00:60',
            end: '24:00'
          }"
          placeholder="选择时间"
          @change="chooseTimethod($event)"
        />
        <el-time-select
          v-model="time1"
          :clearable="false"
          :picker-options="{
            start: '00:00',
            step: '00:60',
            end: '24:00'
          }"
          placeholder="选择时间"
          @change="chooseTimethodone($event)"
        />

      </div>

      <div v-if="radioBabytwo === radiothree" class="main_comp">

        <TimeSlot
          :active-date="time_series"
          @setActiveDate="setActiveDate"
        />

      </div>
    </div>
  </div>
</template>

<script>
import TimeSlot from './timeSlot.vue'
export default {
  components: {
    TimeSlot
  },
  props: {
    startTime: {},
    endTime: {},
    launchTime: {},
    launchPeriod: {},
    time_series: {},
    radioone: {},
    radiotwo: {},
    campaign: {}
  },
  data() {
    return {
      campaignobj: {},
      a: 1,
      b: 2,
      radioBabyone: '',
      radioBabytwo: '',

      radiobig: 'allday',
      radiomiddle: 'sameday',
      radiothree: 'customday',

      alldaytext: '1111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',

      launchTime1: '',
      launchPeriod1: '',
      startTime1: '',
      endTime1: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      chooseTime: '',
      chooseTimeone: '',

      time: '00:00', // 每日投放时段1
      time1: '24:00'// 每日投放时段2
    }
  },
  computed: {
    // creationTimes() {
    //   const date = new Date()
    //   const currentWeek = date.getDay()
    //   const mondayDate = currentWeek > 1 ? new Date(date - (currentWeek - 1) * 24 * 60 * 60 * 1000) : new Date(date - 6 * 24 * 60 * 60 * 1000)
    //   const dates = []
    //   const arr = ['一', '二', '三', '四', '五', '六', '日']
    //   for (let i = 0; i < 7; i++) {
    //     dates.push([])
    //     for (let l = 0; l < 48; l++) {
    //       const date1 = new Date(mondayDate.getFullYear(), mondayDate.getMonth(), mondayDate.getDate() + i, Math.floor(l / 2), l % 2 ? 59 : 30)
    //       const date2 = new Date(date1 - 30 * 60 * 1000)
    //       dates[i].push({
    //         date: date1,
    //         week: '星期' + arr[i],
    //         time: `${date2.getHours().toString().padStart(2, '0')}:${date2.getMinutes().toString().padStart(2, '0')}~${date1.getHours().toString().padStart(2, '0')}:${date1.getMinutes().toString().padStart(2, '0')}`
    //       })
    //     }
    //   }

    //   return dates
    // },
    sum() {
      return this.a + this.b
    }
  },
  created() {
    console.log('campaign', this.campaign)
    this.campaignobj = this.campaign
    if (Number(this.campaign.end_time) !== 0) {
      console.log('11111', this.campaign.end_time)
      this.radioBabyone = 'sone'
    } else {
      console.log('2222', this.campaign.end_time)
      this.radioBabyone = 'sone1'
    }
    // 初始化时间 他这组件只支持毫秒 传进来要改成毫秒
    // console.log('777777777', Math.round(new Date() / 1000))
    this.startTime1 = this.campaign.begin_time !== '' ? Math.round(this.campaign.begin_time * 1000) : new Date().getTime()
    if (this.campaign.begin_time === '') {
      this.$emit('setLaunchTime', {
        begin_date: Math.round(this.startTime1 / 1000),
        end_date: Math.round(this.endTime1 / 1000)
        // time_series: this.time_series
      })
    }

    if (Number(this.campaignobj.end_time) === 0) {
      this.endTime1 = new Date().getTime()
    } else {
      this.endTime1 = this.campaignobj.end_time * 1000
    }

    // this.endTime1 = this.campaignobj.end_time ? new Date(this.campaignobj.end_time) : new Date()

    this.launchTime1 = this.launchTime
    this.launchPeriod1 = this.launchPeriod
    // this.radioBabyone = this.radioone
    // this.radioBabytwo = this.radiotwo
    // console.log('dates', this.creationTimes)
  },
  methods: {
    getNowFormatDay(nowDate) {
      var char = '-'
      if (nowDate == null) {
        nowDate = new Date()
      }
      var day = nowDate.getDate()
      var month = nowDate.getMonth() + 1// 注意月份需要+1
      var year = nowDate.getFullYear()
      // 补全0，并拼接
      return year + char + this.completeDate(month) + char + this.completeDate(day)
    },
    completeDate(value) {
      return value < 10 ? '0' + value : value
    },
    // 开始时间回调
    startChange() {
      if (this.radioBabyone === 'sone1') {
        this.endTime1 = 0
      }
      this.$emit('setLaunchTime', {
        begin_date: Math.round(this.startTime1 / 1000),
        end_date: Math.round(this.endTime1 / 1000)
        // time_series: this.time_series
      })
    },
    // 结束时间回调
    endChange() {
      this.$emit('setLaunchTime', {
        begin_date: Math.round(this.startTime1 / 1000),
        end_date: Math.round(this.endTime1 / 1000)
        // time_series: this.time_series
      })
    },

    setActiveDate(obj) {
      console.log('wo6了')
      this.$emit('setLaunchTime', {
        begin_date: this.startTime1
          .toLocaleDateString()
          .split('/')
          .map(item => {
            return item.padStart(2, '0')
          })
          .join('-'),
        end_date: this.endTime1
          .toLocaleDateString()
          .split('/')
          .map(item => {
            return item.padStart(2, '0')
          })
          .join('-'),
        time_series: obj.text
      })
    },
    // 投放时间回调
    onechange(value) {
      this.radioBabyone = value
      if (this.radioBabyone === 'sone1') {
        this.endTime1 = 0
        console.log('长期投放', this.startTime1, this.endTime1)
        this.$emit('setLaunchTime', {
          begin_date: Math.round(this.startTime1 / 1000),
          end_date: 0
          // time_series: this.time_series
        })
      }
      if (value === 'sone') {
        this.endTime1 = new Date().getTime()
        this.$emit('setLaunchTime', {
          begin_date: Math.round(this.startTime1 / 1000),
          end_date: Math.round(this.endTime1 / 1000)
          // time_series: this.time_series
        })
      }

      this.$emit('setLaunchoose', this.radioBabyone)
    },
    onechangetwo(value) {
      if (value === 'allday') {
        console.log('6666', value)
        this.$emit('setLaunchtimeall', {
          begin_date: this.startTime1
            .toLocaleDateString()
            .split('/')
            .map(item => {
              return item.padStart(2, '0')
            })
            .join('-'),
          end_date: this.endTime1
            .toLocaleDateString()
            .split('/')
            .map(item => {
              return item.padStart(2, '0')
            })
            .join('-'),
          time_series: this.alldaytext
        })
      }
      if (value === 'sameday') {
        this.$emit('setLaunchtimeall', {
          begin_date: this.startTime1
            .toLocaleDateString()
            .split('/')
            .map(item => {
              return item.padStart(2, '0')
            })
            .join('-'),
          end_date: this.endTime1
            .toLocaleDateString()
            .split('/')
            .map(item => {
              return item.padStart(2, '0')
            })
            .join('-'),
          time_series: this.transformation(this.creationTimes, this.time, this.time1)
        })
      }
      this.$emit('setLaunchooseone', value)
    },
    chooseTimethod(event) {
      console.log('val', event)
      this.time = event
      this.$emit('setLaunchtimeall', {
        begin_date: this.startTime1
          .toLocaleDateString()
          .split('/')
          .map(item => {
            return item.padStart(2, '0')
          })
          .join('-'),
        end_date: this.endTime1
          .toLocaleDateString()
          .split('/')
          .map(item => {
            return item.padStart(2, '0')
          })
          .join('-'),
        time_series: this.transformation(this.creationTimes, this.time, this.time1)
      })
    },
    chooseTimethodone(event) {
      console.log('val', event)
      this.time1 = event
      // console.log('   this.creationTimes', this.creationTimes)
      // console.log(this.transformation(this.creationTimes, this.time, this.time1))
      this.$emit('setLaunchtimeall', {
        begin_date: this.startTime1
          .toLocaleDateString()
          .split('/')
          .map(item => {
            return item.padStart(2, '0')
          })
          .join('-'),
        end_date: this.endTime1
          .toLocaleDateString()
          .split('/')
          .map(item => {
            return item.padStart(2, '0')
          })
          .join('-'),
        time_series: this.transformation(this.creationTimes, this.time, this.time1)
      })
    }
    // transformation(dates, date1, date2) {
    //   console.log(dates, date1, date2)
    //   let str = ''
    //   for (let i = 0; i < dates.length; i++) {
    //     for (let l = 0; l < dates[i].length; l++) {
    //       const clock = dates[i][l].date.getHours() * 60 * 60 * 1000
    //       const branch = dates[i][l].date.getMinutes() * 60 * 1000
    //       const s = date1.split(':')
    //       const s1 = date2.split(':')
    //       const clock1 = s[0] * 60 * 60 * 1000
    //       const branch1 = s[1] * 60 * 1000
    //       const clock2 = s1[0] * 60 * 60 * 1000
    //       const branch2 = s1[1] * 60 * 1000

    //       if (clock + branch >= clock1 + branch1 && clock + branch <= clock2 + branch2) {
    //         str += '1'
    //       } else {
    //         str += '0'
    //       }
    //     }
    //   }
    //   return str
    // }
  }
}
</script>

<style scoped lang="less">
.launchTime {
  width: 100%;
  padding: 0 0 32px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 6px 0 rgb(0 0 0 / 4%), 0 0 0 1px hsl(0deg 0% 87% / 50%);
  margin-bottom: 12px;
  .launchTime_titleArea {
    padding: 18px 24px;
    border-bottom: 1px solid #f2f2f2;
    .title {
      margin-bottom: 2px;
      font-size: 14px;
      line-height: 24px;
      color: #1f1f1f;
      font-weight: 600;
    }
  }

  .launchTime_main {
    padding: 0px 24px;
    .main_item {
      display: flex;
      margin: 10px 0px;
      align-items: center;
      .item_title {
        width: 110px;
        .text {
        }
      }
      .item_main {
      }
    }

    .main_comp {
      height: 307px;
      width: 100%;
    }
  }
}
</style>
